import React from 'react'
import DocumentsViewComponent from '../Components/Documents/DocumentsViewComponent'

const DocumentView = () => {
  return (
    <>
      <DocumentsViewComponent/>
    </>
  )
}

export default DocumentView
